<template>
  <fieldset class="tab tab-07">
    <div class="heading-form a-center">
      <span class="number">7/11</span>
      <p class="c-yellow">ไลฟ์สไตล์ของคุณ</p>
      <h2 class="heading-h2 c-white">คุณดูแลใส่ใจสุขภาพอย่างไร</h2>
      <p class="desc">(เลือกได้มากกว่า 1 ข้อ)</p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div
            class="icw-input icw-input-checkbox icon-none icw-input-full c-lifestyle"
          >
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle2"
                id="exercise"
                class="css-checkbox more-workout"
                value="exercise"
                v-model="healthy"
                @change="checkValue($event)"
              />
              <label for="exercise" class="css-label"
                ><i class="ic ic-exercise"></i>ออกกำลังกาย</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle2"
                id="healthy"
                class="css-checkbox"
                value="cleanfood"
                v-model="healthy"
                @change="checkValue($event)"
              />
              <label for="healthy" class="css-label"
                ><i class="ic ic-salad"></i>รับประทานอาหารเพื่อสุขภาพ</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle2"
                id="relaxing"
                class="css-checkbox"
                value="relax"
                v-model="healthy"
                @change="checkValue($event)"
              />
              <label for="relaxing" class="css-label"
                ><i class="ic ic-massage"></i>นวด, สปา,
                <br />อโรมาเธอราปี</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="lifestyle2"
                id="notsee"
                class="css-checkbox"
                value="-1"
                v-model="healthy"
                @change="checkValue($event)"
              />
              <label for="notsee" class="css-label"
                ><i class="ic ic-no"></i>ยังไม่เห็นความสำคัญ</label
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-07', 'tab-06')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      type="button"
      id="btnNextStepQ8"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>

    <a
      href="#popup-input-workout-type"
      class="popup-input-workout-type"
      style="display: none;"
      >click me</a
    >
    <div id="popup-input-workout-type" class="mfp-hide modal-input">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <div class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">การออกกำลังกายที่คุณชื่นชอบ</h3>
                  <p class="desc">เลือกได้มากกว่า 1 ข้อ</p>
                </div>
                <div id="moreActivities" class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input icw-input-checkbox">
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox21"
                            class="css-checkbox"
                            value="fitness"
                            v-model="more_healthy"
                          />
                          <label for="checkbox21" class="css-label"
                            >เล่นฟิตเนส</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox22"
                            class="css-checkbox"
                            value="runing"
                            v-model="more_healthy"
                          />
                          <label for="checkbox22" class="css-label">วิ่ง</label>
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox23"
                            class="css-checkbox"
                            value="walk"
                            v-model="more_healthy"
                          />
                          <label for="checkbox23" class="css-label">เดิน</label>
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox24"
                            class="css-checkbox"
                            value="yoga"
                            v-model="more_healthy"
                          />
                          <label for="checkbox24" class="css-label">โยคะ</label>
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox25"
                            class="css-checkbox"
                            value="swiming"
                            v-model="more_healthy"
                          />
                          <label for="checkbox25" class="css-label"
                            >ว่ายน้ำ</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox26"
                            class="css-checkbox"
                            value="bike"
                            v-model="more_healthy"
                          />
                          <label for="checkbox26" class="css-label"
                            >ปั่นจักรยาน</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox27"
                            class="css-checkbox"
                            value="aerobic"
                            v-model="more_healthy"
                          />
                          <label for="checkbox27" class="css-label"
                            >เต้นแอโรบิก</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox28"
                            class="css-checkbox"
                            value="socker"
                            v-model="more_healthy"
                          />
                          <label for="checkbox28" class="css-label"
                            >เล่นฟุตบอล</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox29"
                            class="css-checkbox"
                            value="golf"
                            v-model="more_healthy"
                          />
                          <label for="checkbox29" class="css-label"
                            >ตีกอล์ฟ</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox210"
                            class="css-checkbox"
                            value="extreme"
                            v-model="more_healthy"
                          />
                          <label for="checkbox210" class="css-label"
                            >เล่นกีฬาเอ็กซ์ตรีม</label
                          >
                        </div>
                        <div class="checkbox checkbox-default">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            id="checkbox211"
                            class="css-checkbox"
                            value="etc"
                            v-model="more_healthy"
                          />
                          <label for="checkbox211" class="css-label"
                            >อื่นๆ</label
                          >
                          <input
                            type="text"
                            id="txtEtcExercise"
                            placeholder="โปรดระบุ"
                            name="more_healthy_text"
                            :disabled="more_healthy.indexOf('etc') == -1"
                            v-model="more_healthy_text"
                          />
                        </div>
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          type="button"
                          id="btnSubmitExercise"
                          class="btn"
                          :class="{ 'btn-disabled': more_healthy.length == 0 }"
                          @click="ConfJobText()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep1_Q7",
  props: {
    QuestionType: String
  },
  data() {
    return {
      healthy:
        my_storage(this.QuestionType, "healthy") == ""
          ? []
          : my_storage(this.QuestionType, "healthy"),
      more_healthy:
        my_storage(this.QuestionType, "more_healthy") == ""
          ? []
          : my_storage(this.QuestionType, "more_healthy"),
      more_healthy_text: my_storage(this.QuestionType, "more_healthy_text")
    };
  },
  mounted() {
    this.checkValue();

    this.$nextTick(() => {
      $(".popup-input-workout-type").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".more-workout").click(function() {
        $(".popup-input-workout-type").trigger("click");
      });

      let self = this;

      $(".popup-input-workout-type").on("mfpClose", function() {
        if (
          $("#moreActivities").find("input[type=checkbox]:checked").length > 0
        ) {
          if (
            $("#moreActivities").find("input[type=checkbox][value=etc]:checked")
              .length > 0 &&
            $("#moreActivities")
              .find("input[name=more_healthy_text]")
              .val()
              .trim() == ""
          ) {
            $("#moreActivities")
              .find("input[type=checkbox][value=etc]")
              .prop("checked", false);
            $("input[type=checkbox][value=exercise]").prop("checked", false);
            self.healthy.splice(self.healthy.indexOf("exercise"), 1);
            self.more_healthy.splice(self.more_healthy.indexOf("etc"), 1);
          } else {
            if (self.healthy.indexOf("exercise") == -1) {
              self.healthy.push("exercise");
            }
            $("input[type=checkbox][value=exercise]").prop("checked", true);
          }
        } else if (
          $("#moreActivities").find("input[type=checkbox]:checked").length == 0
        ) {
          self.healthy.splice(self.healthy.indexOf("exercise"), 1);
        } else {
          if (self.healthy.indexOf("exercise") == -1) {
            self.healthy.push("exercise");
          }
          $("input[type=checkbox][value=exercise]").prop("checked", false);
        }
      });
    });
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      let pass = false;
      if (this.healthy.length > 0) {
        if (this.healthy.indexOf("etc") > -1 && this.more_healthy.length > 0) {
          pass = true;
        } else if (this.healthy.indexOf("etc") == -1) {
          pass = true;
        }
      }

      if (pass) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;

        this.nextStep("tab-07", "tab-08");
      }
    },
    checkValue(event) {
      if (this.healthy.indexOf("-1") > -1) {
        this.healthy = ["-1"];
        this.more_healthy = [];
        this.more_healthy_text = "";
        this.$nextTick(() => {
          $(this.$el)
            .find(".checkbox.checkbox-inline")
            .each(function() {
              if (
                $(this)
                  .find("input[type=checkbox]")
                  .val() != "-1"
              ) {
                $(this)
                  .find("input[type=checkbox]")
                  .prop("disabled", true);
              }
            });
        });
      } else if (this.healthy.indexOf("-1") == -1) {
        this.$nextTick(() => {
          $(this.$el)
            .find(".checkbox.checkbox-inline")
            .each(function() {
              $(this)
                .find("input[type=checkbox]")
                .prop("disabled", false);
            });
        });
      }
    },
    ConfJobText() {
      if (this.more_healthy.length > 0) {
        if (
          this.more_healthy.indexOf("etc") > -1 &&
          this.more_healthy_text.trim() != ""
        ) {
          $.magnificPopup.close();
        } else if (
          this.more_healthy.indexOf("etc") == -1 &&
          this.more_healthy_text.trim() == ""
        ) {
          $.magnificPopup.close();
        }
      }
    }
  },
  computed: {
    isPass() {
      let pass = false;
      if (this.healthy.length > 0) {
        if (this.healthy.indexOf("etc") > -1 && this.more_healthy.length > 0) {
          pass = true;
        } else if (this.healthy.indexOf("etc") == -1) {
          pass = true;
        }
      } else if (this.healthy.length == 0 && this.more_healthy.length > 0) {
        if (this.healthy.indexOf("exercise") == -1) { this.healthy.push("exercise"); }
        pass = true;
      }

      return pass;
    }
  }
};
</script>
